import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import upload from './upload/reducer';
import menuRole from './menuRole/reducer';
import reportBugs from './reportBugs/reducer';
import adminCommunication from './adminCommunication/reducer';
import supplierCommunication from './communication/supplierCommunication/reducer';
import supplierCommunicationInfra from './communication/supplierCommunicationInfra/reducer';
import communicationInfra from './communication/communicationInfra/reducer';
import comCatalog from './communication/catalog/reducer';
import comArea from './communication/area/reducer';

import speTool from './speTool/reducer';
import hnEvaluation from './hospitalNet/evaluation/reducer';
/*M�dulo Calidad Med y MMQ*/
import healthRegistration from './quality/healthRegistration/reducer';
import healthLicense from './quality/healthLicense/reducer';
import healthBPM from './quality/healthBPM/reducer';
import productInfo from './quality/productInfo/reducer';
import idxRptQuality from './quality/idxRptQuality/reducer';

/*M�dulo Finanzas*/
import cashReceipt from './finance/cashReceipt/reducer';
import paymentReceipt from './finance/paymentReceipt/reducer';

import assessment from './assessment/assessment/reducer';
import section from './assessment/section/reducer';
import question from './assessment/question/reducer';
import section_equipment from './assessment/section_equipment/reducer';
import answer from './assessment/answer/reducer';
import assessment_project from './assessment/assessment_project/reducer';
import evaluation from './assessment/evaluation/reducer';
import evaluation_detail from './assessment/evaluation_detail/reducer';
import assessment_document_type from './assessment/document_type/reducer';
import document from './assessment/document/reducer';
import evaluation_state from './assessment/evaluation_state/reducer';
import assessment_type from './assessment/assessment_type/reducer';
import evaluation_role from './assessment/evaluation_role/reducer';
import evaluation_user from './assessment/evaluation_user/reducer';
import evaluation_message from './assessment/evaluation_message/reducer';
import equipment_stock from './assessment/equipment_stock/reducer';
import equipment_stock_detail from './assessment/equipment_stock_detail/reducer';
import equipment_stock_detail_item from './assessment/equipment_stock_detail_item/reducer';
import assessment_category from './assessment/assessment_category/reducer';
import equipment from './assessment/equipment/reducer';
import idxRptEquipment from './assessment/idxRptEquipment/reducer';
import otherReassignation from './assessment/otherReassignation/reducer';

/*Equipment*/
import trackingInstallation from './equipment/trackingInstallation/reducer';
import assignTechnic from './equipment/assignTechnic/reducer';
import validationDocumentReview from './equipment/validationDocumentReview/reducer';
import scheduleMto from './equipment/scheduleMto/reducer';
import request from './equipment/request/reducer';
import task from './task/reducer';
import taskType from './taskType/reducer';
import mgmt_program from './management/program/reducer';
import mgmt_component from './management/component/reducer';
import mgmt_project from './management/project/reducer';
import mgmt_objective from './management/objective/reducer';
import mgmt_outcome from './management/outcome/reducer';
import delivery_plan from './delivery_plan/delivery_plan/reducer';
import delivery_plan_documentation from './delivery_plan/documentation/reducer';
import delivery_plan_audit from './delivery_plan/delivery_plan_audit/reducer';
import task_inspection from './delivery_plan/task_inspection/reducer';
import task_inspection_destination from './delivery_plan/task_inspection_destination/reducer';
import task_delivery from './delivery_plan/task_delivery/reducer';
import acquisition from './acquisition/acquisition/reducer';
import acquisition_detail from './acquisition/acquisition_detail/reducer';
import acquisition_detail_not_biddable from './acquisition/acquisition_detail_not_biddable/reducer';
import task_equipment from './task_equipment/reducer';
import cat_vehicle_type from './catalog/vehicle_type/reducer';
import sup_vehicle from './supplier/vehicle/reducer';
import sup_employee from './supplier/employee/reducer';
import ent_supplier from './enterprise/supplier/reducer';
import ent_supplier_user from './enterprise/supplier_user/reducer';
import task_employee from './task/task_employee/reducer';
import task_employee_audit from './task/task_employee_audit/reducer';
import task_vehicle from './task/task_vehicle/reducer';
import task_vehicle_audit from './task/task_vehicle_audit/reducer';

import idxPaymentReport from './report/idxPaymentReport/reducer';

import ambulanceDocument from './ambulance/document/reducer';
import ambulanceMaintenance from './ambulance/maintenance/reducer';

import infrastructureDeliverable from './infrastructure/deliverable/reducer';
import infrastructureLogbook from './infrastructure/logbook/reducer';

const reducers = combineReducers({
    menu,
    settings,
    authUser,
    upload,
    menuRole,
    reportBugs,
    adminCommunication,
    supplierCommunication,
    supplierCommunicationInfra,
    communicationInfra,
    comCatalog,
    comArea,
    speTool,
    healthRegistration,
    healthLicense,
    healthBPM,
    productInfo,
    idxRptQuality,

    cashReceipt,
    paymentReceipt,

    hnEvaluation,
    assessment,
    section,
    question,
    section_equipment,
    answer,
    assessment_project,
    evaluation,
    evaluation_detail,
    assessment_document_type,
    document,
    evaluation_state,
    assessment_type,
    evaluation_role,
    evaluation_user,
    evaluation_message,
    equipment_stock,
    equipment_stock_detail,
    equipment_stock_detail_item,
    assessment_category,
    equipment,
    idxRptEquipment,
    otherReassignation,

    trackingInstallation,
    assignTechnic,
    validationDocumentReview,
    scheduleMto,
    request,
    task,
    taskType,
    mgmt_program,
    mgmt_component,
    mgmt_project,
    mgmt_objective,
    mgmt_outcome,
    delivery_plan,
    delivery_plan_documentation,
    delivery_plan_audit,
    task_inspection,
    task_inspection_destination,
    task_delivery,
    acquisition,
    acquisition_detail,
    acquisition_detail_not_biddable,
    task_equipment,
    cat_vehicle_type,
    sup_vehicle,
    sup_employee,
    ent_supplier,
    ent_supplier_user,
    task_employee,
    task_employee_audit,
    task_vehicle,
    task_vehicle_audit,
    idxPaymentReport,
    ambulanceDocument,
    ambulanceMaintenance,
    infrastructureDeliverable,
    infrastructureLogbook,
});

export default reducers;
